import React from 'react';
import ReactDOM from 'react-dom/client';
import reactToWebComponent from 'react-to-webcomponent';
import AiTalk from './AiTalk';

// Define the custom element
const AiTalkElement = reactToWebComponent(AiTalk, React, ReactDOM, {
	props: {
		assistantId: 'string',
		assistantLabel: 'string',
	},
	attributeMapping: {
		assistantid: 'assistantId',
		assistantlabel: 'assistantLabel',
	}
});
customElements.define('ai-talk', AiTalkElement);
